import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1>Payment System Coming soon!!!</h1>
        </div>
    );
};

export default Payment;